import { render, staticRenderFns } from "./How_it_works.vue?vue&type=template&id=27c23f24&"
import script from "./How_it_works.vue?vue&type=script&lang=js&"
export * from "./How_it_works.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports